import {CommonModalService} from '../../common-modal/common-modal.service';
import {CommonModalTemplatesEnum, ICommonModalBase} from '../all-modals-config';
import { OnDestroy, OnInit, Directive } from '@angular/core';
import { ModalInformationAndActionDataInterface } from '../modal-information-and-action-component/modal-information-and-action-data.interface';

@Directive()
export abstract class CommonModalBase<T extends ICommonModalBase> implements OnInit, OnDestroy {
  public modalData: ModalInformationAndActionDataInterface = null;

  private modalsSubscription;

  protected constructor (
    private commonModalService: CommonModalService,
    public templateName: CommonModalTemplatesEnum
  ) {
    this.commonModalService = commonModalService;
    this.templateName = templateName;
  }

  ngOnInit(): void {
    this.onInit();
  }

  ngOnDestroy(): void {
    this.onDestroy();
  }

  public getModalSources() {
    return this.commonModalService.getModalsObs();
  }

  private onInit() {
    this.modalsSubscription = this.getModalSources().subscribe(
      (modalData: ModalInformationAndActionDataInterface) => {
        if (!modalData) {
          return;
        }

        this.setData(modalData);
      }
    );
  }

  private onDestroy() {
    this.modalsSubscription.unsubscribe();
  }

  private setData(newModalData: ModalInformationAndActionDataInterface) {
    if (newModalData.templateName !== this.templateName) {
      return;
    }

    if (newModalData._data){
      this.commonModalService.showCloseBtn = newModalData._data.showCloseBtn;
    }

    this.modalData = newModalData;
  }

  public closeAllModalsAfterDelay(delay: number) {
    setTimeout(() => this.commonModalService.closeAllModals(), delay)
  }
}
